import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { ItemRow } from '../item-row';
import { ItemImage } from '../item-image';
import { ItemInfo } from '../item-info';
import { ItemCount } from '../item-count';

import style from './style.module.less';

export const ScanToPrintRow = ({
  currentlyVerifyingItemId = '',
  itemId = '',
  imageSrc = '',
  name = '',
  sku = '',
  upc = '',
  itemQuantity = 0,
}) => {
  const isCurrentlyVerifying = currentlyVerifyingItemId === itemId;
  return (
    <ItemRow
      cellClassName={classnames(style['row-cell'], {
        [style.verifying]: isCurrentlyVerifying,
      })}
      image={<ItemImage alt={name} src={imageSrc} />}
      itemCount={<ItemCount count={itemQuantity} />}
      itemId={itemId}
      itemInfo={<ItemInfo name={name} sku={sku} upc={upc} />}
      scanToPrint
    />
  );
};

ScanToPrintRow.propTypes = {
  itemId: PropTypes.string,
  imageSrc: PropTypes.string,
  name: PropTypes.string,
  sku: PropTypes.string,
  upc: PropTypes.string,
  itemQuantity: PropTypes.number,
  currentlyVerifyingItemId: PropTypes.string,
};
